// Copyright (c) 2026. Hardfin, Inc. All rights reserved.

/**
 * Centralized query-key factories for the SFDC drift-resolution hooks.
 * Mutation hooks invalidate via these helpers so adding a new entity
 * type doesn't fragment the cache.
 */
import { SFDCDriftEntityType } from '@/sfdc/api/types';

export function sfdcDriftDiffQueryKey(
  entityType: SFDCDriftEntityType,
  entityKey: string
): readonly unknown[] {
  return ['sfdc', 'drift', entityType, entityKey, 'diff'];
}

/**
 * Detail-page query key for the Hardfin entity backing a drift binding.
 * Pull/Dismiss invalidate this so the entity's Integration envelope
 * (carrying needsReview) refetches and the blue-dot indicator updates.
 *
 * Mirror the canonical key the entity's own hook uses (e.g.,
 * `['location', locationKey]` from useLocation). When customer /
 * project come online, widen `SFDCDriftEntityType` and add cases here —
 * TS will flag every call site that needs an update.
 */
export function sfdcDriftEntityDetailQueryKey(
  entityType: SFDCDriftEntityType,
  entityKey: string
): readonly unknown[] {
  return [entityType, entityKey];
}
